import { mapActions } from "vuex";

export default {
  methods: {
    successSaved(){
      this.addNotification({type: 'success', msg: 'Salvo com sucesso!'})
    },
    successUpdated(){
      this.addNotification({type: 'success', msg: 'Atualizado com sucesso!'})
    },
    successDeleted(){
      this.addNotification({type: 'success', msg: 'Excluido com sucesso!'})
    },
    errorUpdated(){
      this.addNotification({type: 'error', msg: 'Erro ao atualizar!'})
    },
    errorCreated(){
      this.addNotification({type: 'error', msg: 'Erro ao criar!'})
    },
    /** Mensagem a partir de `error.response.data.errors` (array ou string) ou fallback. */
    apiErrorsMessage(error, fallback = 'Não foi possível concluir a operação.') {
      try {
        let data = error.response && error.response.data
        if (!data) return fallback
        if (Array.isArray(data.errors) && data.errors.length)
          return data.errors.join('. ')
        if (typeof data.errors === 'string' && data.errors.trim())
          return data.errors.trim()
      } catch (e) {
      }
      return fallback
    },
    notifyApiError(error, fallback) {
      this.addNotification({ type: 'error', msg: this.apiErrorsMessage(error, fallback) })
    },
    missingFields(){
      this.addNotification({type: 'error', msg: 'Preencha todos os campos!'})
    },
    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
}